<div [class]="'items-' + align" class="flex flex-col">
  <div class="dsi-title">{{ title }}</div>
  <div class="dsi-value"><strong>{{ value }} {{ suffix }}</strong></div>
</div>
